var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 42,
    viewBox: "0 0 30 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 42,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Agreement - After Sign Copy"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -82,
    y: -358,
    width: 360,
    height: 800,
    rx: 12,
    fill: "#021239"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1973353027"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 10902",
    x: -62,
    y: -79,
    width: 153,
    height: 200,
    rx: 12,
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    opacity: 0.2,
    clipPath: "url(#clip0_2892_239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.06249 26.6876C7.53549 26.6876 7.06118 26.4768 6.63957 26.0025C5.95447 25.212 5.90176 24.2107 6.58687 23.4202C7.11388 22.735 8.16789 22.1553 9.64351 21.6283C10.1705 21.4702 10.7502 21.2594 11.3299 21.154C11.6988 20.4689 12.0677 19.7311 12.3839 18.9406C12.7001 18.2028 12.9637 17.5177 13.1745 16.8326C12.3312 15.4097 11.5407 13.7232 11.5934 12.4057C11.5934 11.2463 12.2785 10.5085 13.3853 10.3504C14.3866 10.245 15.1244 10.7193 15.4406 11.6679C15.8622 12.9327 15.4406 14.8826 14.9663 16.5691C15.3879 17.2542 15.8622 17.9393 16.4419 18.6244C16.9162 19.2041 17.3378 19.7311 17.8121 20.2581C19.6566 20.2581 21.3958 20.4162 22.4498 20.9959C23.3984 21.5229 23.7673 22.3134 23.5038 23.2621C23.1876 24.3161 22.3444 24.8431 21.2904 24.685C19.9201 24.5269 18.3391 23.2094 17.127 21.9445C16.2838 21.9972 15.3352 22.0499 14.3866 22.208C13.7015 22.3134 13.0164 22.4188 12.3839 22.5769C12.1731 22.9985 11.9096 23.3675 11.6988 23.6837C10.8029 25.0012 9.95971 25.8971 9.16921 26.3714C8.8003 26.5822 8.4314 26.6876 8.06249 26.6876ZM10.1178 23.2094C9.0111 23.5783 8.16789 24.0526 7.79899 24.4742C7.64089 24.6323 7.64089 24.7377 7.85169 25.0012C7.95709 25.1066 8.00979 25.212 8.4314 25.0012C8.9057 24.685 9.53811 24.0526 10.1178 23.2094ZM19.4985 21.9972C20.289 22.6823 20.9742 23.1039 21.5012 23.1567C21.712 23.2094 21.8174 23.2094 21.9755 22.8404C22.0282 22.735 22.0282 22.6823 21.712 22.4715C21.2377 22.2607 20.4471 22.0499 19.4985 21.9972ZM14.3339 18.5717C14.1758 18.9933 14.0177 19.3622 13.9123 19.6257C13.7542 20.0473 13.5434 20.4162 13.3853 20.7851C13.6488 20.7324 13.9123 20.6797 14.1758 20.6797C14.7028 20.627 15.2298 20.5216 15.7568 20.5216C15.4933 20.2054 15.2825 19.9419 15.1771 19.7838C14.9663 19.4676 14.6501 19.046 14.3339 18.5717ZM13.5961 11.9841C13.3853 12.0368 13.2272 12.0368 13.2272 12.4584C13.2272 12.9854 13.438 13.7232 13.8596 14.6191C14.0704 13.5651 14.1231 12.7219 13.965 12.2476C13.8596 11.9841 13.8069 11.9841 13.5961 11.9841Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.48303 30.3257C7.48303 29.8514 7.79924 29.6406 8.16814 29.6406H9.90726C11.014 29.6406 12.068 30.3257 12.068 31.7487C12.068 32.9608 11.3302 33.8567 9.95996 33.8567H8.90595V35.1742C8.90595 35.6485 8.58975 35.912 8.22084 35.912C7.79924 35.912 7.53573 35.6485 7.53573 35.1742V30.3257H7.48303ZM8.90595 32.5919H9.64376C10.2235 32.5919 10.5924 32.1703 10.5924 31.7487C10.5924 31.1689 10.2235 30.9054 9.64376 30.9054H8.90595V32.5919Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.8059 30.3257C12.8059 29.8514 13.1221 29.6406 13.491 29.6406H15.1774C17.022 29.6406 18.076 31.1162 18.076 32.6973C18.076 34.7526 16.7058 35.8593 15.1774 35.8593H13.491C13.1221 35.8593 12.8059 35.5958 12.8059 35.1742V30.3257ZM14.2288 34.5418H14.9666C16.0733 34.5418 16.6004 33.804 16.6004 32.6973C16.6004 31.5905 16.0733 30.9581 15.0193 30.9581H14.2288V34.5418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.9187 30.3257C18.9187 29.8514 19.2349 29.6406 19.6038 29.6406H21.7645C22.1861 29.6406 22.4496 29.9041 22.4496 30.273C22.4496 30.6946 22.1861 30.9054 21.7645 30.9054H20.2889V32.0122H21.5537C21.9753 32.0122 22.2388 32.2757 22.2388 32.6446C22.2388 33.0662 21.9753 33.277 21.5537 33.277H20.2889V35.0688C20.2889 35.5431 19.9727 35.8066 19.6038 35.8066C19.1822 35.8066 18.9187 35.5431 18.9187 35.0688V30.3257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M28.5109 10.9807C28.0893 10.9807 27.7204 11.3496 27.7204 11.7713V38.4378C27.7204 39.3337 26.9826 40.0715 26.0867 40.0715H3.21462C2.31871 40.0715 1.5809 39.3337 1.5809 38.4378V3.23375C1.5809 2.33784 2.31871 1.60003 3.21462 1.60003H19.868V6.50119C19.868 8.08221 21.1855 9.39972 22.7666 9.39972H28.4582C28.7744 9.39972 29.0906 9.18892 29.196 8.92542C29.3014 8.66192 29.2487 8.29301 29.0379 8.02951L21.2382 0.229811C21.0274 0.0190081 20.7639 -0.0336926 20.5531 0.0190081H3.26732C1.4755 0.0190081 -0.00012207 1.49463 -0.00012207 3.28645V38.4905C-0.00012207 40.2823 1.4755 41.7579 3.26732 41.7579H26.0867C27.8785 41.7579 29.3541 40.2823 29.3541 38.4905V11.7713C29.3014 11.3496 28.9852 10.9807 28.5109 10.9807ZM22.7666 7.766C22.0288 7.766 21.449 7.1863 21.449 6.44849V2.65404L26.561 7.766H22.7666Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2892_239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.3543,
    height: 41.76,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfFile);
export default __webpack_public_path__ + "static/media/pdfFile.8f75e9d48e7d2618293ef427d95dd9b2.svg";
export { ForwardRef as ReactComponent };